import React, { ReactNode } from 'react'

import { useMobile } from 'hooks/ua'

import styles from './style.less'

export interface Props {
  title?: ReactNode
  icon: string
}

export default function ContactItem(props: Props) {
  const { icon, title } = props
  const isMobile = useMobile()

  return (
    <div className={isMobile ? styles.mobileItem : styles.pcItem}>
      <div className={styles.imgWrap}>
        <img src={icon} className={styles.img} />
      </div>
      <div className={styles.title}>{title}</div>
    </div>
  )
}
